import React from 'react';

const SymbolKey = ({sign,message}) => {
    return (
        <div className="p-4 bg-teal-100 rounded-lg shadow-md w-full mx-auto">
          <ul className="space-y-3">
            {
                sign === 'star' && 
                <li className="flex items-start">
                <span className="text-2xl mr-2">*</span>
                <span className="text-gray-700">
                    {message}
                </span>
                </li>
            }
            {
                sign === 'hash' &&
                <li className="flex items-start">
                <span className="text-2xl mr-2">#</span>
                <span className="text-gray-700">
                    {message}
                </span>
                </li>
            }  
            {
                sign === 'plus' &&
                <li className="flex items-start">
                <span className="text-2xl mr-2">+</span>
                <span className="text-gray-700">
                    {message}
                </span>
                </li>
            }            
          </ul>
        </div>
    );
};

export default SymbolKey;